import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {injectIntl} from 'react-intl';

class Terms extends Component {
  constructor(props) {
    super(props);

    this.close = this.close.bind(this);
  }

  // eslint-disable-next-line class-methods-use-this
  componentDidMount() {
    if (window.self === window.top) {
      document.body.className = 'terms-bg';
    }
  }

  close() {
    window.location.href = this.props.location.query.redirectUrl
      .replace('%3A', ':')
      .replace(new RegExp('%2F', 'g'), '/');
  }

  render() {
    const {
      intl,
      location: {query}
    } = this.props;

    return (
      <div className="terms-page">
        <button
          id="decline_terms__cross"
          onClick={this.close}
          className="terms-page__close-button"
        />
        <div className="terms" dangerouslySetInnerHTML={{__html: intl.messages.terms}} />
        <div className="terms-page__footer">
          <div className="terms-page__footer__inner">
            <Link
              id="accept_terms"
              className="form-button terms-page__button terms-page__button--accept"
              to={{pathname: '/verification', query}}
            >
              {intl.messages['btn.accept']}
            </Link>
            <a
              id="decline_terms"
              onClick={this.close}
              className="form-button button-outline terms-page__button terms-page__button--decline"
            >
              {intl.messages['btn.decline']}
            </a>
          </div>
        </div>
      </div>
    );
  }
}

Terms.propTypes = {
  location: PropTypes.object.isRequired,
  intl: PropTypes.object,
  xl: PropTypes.object.isRequired
};

export default injectIntl(connect(state => state)(Terms));



// WEBPACK FOOTER //
// ./pages/Terms.jsx